import TableTemplate from "src/components/Layouts/TableTemplate";
import useTransformRowData from "../../hooks/useTransformRowData";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { FilterFields } from "../../types/FilterFields";
import { GetListRes } from "../../types/GetListRes";
import useTableColumns from "./hooks/useTableColumns";
import DialogProvider from "src/features/DialogProvider";

function Table() {
  const { list, translatePrefix } = usePageConfigProviderContext<
    FilterFields,
    GetListRes
  >();

  const { columns } = useTableColumns({ translatePrefix });

  const { rows } = useTransformRowData({ apiList: list });

  return (
    <DialogProvider>
      <TableTemplate columns={columns} rows={rows} />
    </DialogProvider>
  );
}

export default Table;
